// extracted by mini-css-extract-plugin
export var buttonClassName = "DoctorsSection-module--buttonClassName--f31e8";
export var cardContainer = "DoctorsSection-module--cardContainer--7fd82";
export var cardContent = "DoctorsSection-module--cardContent--192a7";
export var contentCardFooter = "DoctorsSection-module--contentCardFooter--84e40";
export var contentClassName = "DoctorsSection-module--contentClassName--a710a";
export var ctaButtonStyling = "DoctorsSection-module--ctaButtonStyling--e3347";
export var doctorsContainer = "DoctorsSection-module--doctorsContainer--6961d";
export var doctorsContentContainerMobile = "DoctorsSection-module--doctorsContentContainerMobile--bafb3";
export var doctorsHeader = "DoctorsSection-module--doctorsHeader--a2462";
export var doctorsLight = "DoctorsSection-module--doctorsLight--911d4";
export var sectionControls = "DoctorsSection-module--sectionControls--d27e2";
export var swiperSlide = "DoctorsSection-module--swiperSlide--4d96c";